import styled, { css } from 'styled-components';
import { device } from '@core-const';
import { FlexCenter } from 'app-styled/flex';

export const ImageContainer = styled(FlexCenter)`
  .square-box{
    width: 70%;
    margin:5%;
    margin-top: 15%;
    position: relative;
    overflow: hidden;
    ${({ theme }) => css`
      @media ${device.laptop} {
        width: 225px;
        margin: ${theme['thm-space-md']};
      }
    `}
  }
  .square-box:before{
    content: "";
    display: block;
    padding-top: 100%;
  }
  .square-content{
    position:  absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    color: white;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .width-auto {  
    height: 100%;
    width: auto;
  }
  .height-auto {  
    height: auto;
    width: 100%;
  }
`;
